import { formatDateShort, formatMoney } from "../../utils/format"

// Wording for a unit waiting for tenant approval. The manager assigns; nobody
// becomes a tenant, or pays anything, until the tenant approves and pays. These
// texts say exactly what each step does.

export const WAITING_FOR_TENANT_APPROVAL = "Waiting for Tenant Approval"

export const describeInvitationTitle = (invitation = {}) =>
  `${invitation.propertyName || "A property"} · Unit ${invitation.unitLabel || "-"}`

export const describeBellRow = (invitation = {}) => ({
  title: `${invitation.managerName || "A manager"} assigned you to Unit ${invitation.unitLabel || "-"}`,
  subtitle: `${invitation.propertyName || "Property"} · Approve & Pay ${formatMoney(invitation.totalDueNow)} to move in. Only approve if you are renting this unit.`,
})

export const describeWalletState = (invitation = {}) => {
  if (invitation.unitTaken) {
    return { tone: "error", text: "Someone else has moved into this unit. You can no longer approve it." }
  }
  if (Number(invitation.shortfall || 0) > 0) {
    return {
      tone: "warning",
      text: `Top up ${formatMoney(invitation.shortfall)} to your Rentals wallet before approving.`,
    }
  }
  return { tone: "ok", text: "Your Rentals wallet has enough to approve and pay." }
}

export const buildAcceptConfirm = (invitation = {}) => ({
  title: "Approve and pay now?",
  message: `${formatMoney(invitation.totalDueNow)} is paid from your Rentals wallet now and you move in. After that, rent of ${formatMoney(invitation.monthlyRent)} is paid from your wallet each month.`,
  details: [
    { label: "Unit", value: describeInvitationTitle(invitation) },
    { label: "Move-in", value: formatDateShort(invitation.moveInDate) },
    { label: "Pay now", value: formatMoney(invitation.totalDueNow) },
  ],
  confirmLabel: `Approve & Pay ${formatMoney(invitation.totalDueNow)}`,
})

export const buildDeclineConfirm = (invitation = {}) => ({
  title: "Decline this unit?",
  message: `You will not become the tenant of Unit ${invitation.unitLabel || "-"}. Nothing is charged. The manager can assign you again if this was a mistake.`,
  confirmLabel: "Decline",
})

export const describeAcceptResult = (result = {}, invitation = {}) =>
  `You are now the tenant of Unit ${result.unitLabel || invitation.unitLabel || "-"}. ${formatMoney(result.amountPaid)} was paid. Rent is paid from your Rentals wallet each month.`

// Manager side: the result popup after Assign.
export const buildAssignedResult = ({ tenantName, unitLabel, amountDue }) => ({
  status: "success",
  title: WAITING_FOR_TENANT_APPROVAL,
  statusLabel: WAITING_FOR_TENANT_APPROVAL,
  message: `${tenantName} is assigned to Unit ${unitLabel}. They must approve and pay in their own RecordLOGS account. The move-in is complete only after they pay.`,
  details: [
    { label: "Unit", value: unitLabel },
    { label: "Tenant", value: tenantName },
    { label: "Paid on approval", value: formatMoney(amountDue) },
  ],
})

// Manager side: the popup when the tenant's wallet cannot cover the move-in.
export const buildInsufficientFundsResult = (funds = {}) => ({
  status: "error",
  title: "Tenant Assignment Failed",
  statusLabel: "Tenant Assignment Failed",
  message: "Insufficient funds in tenant wallet.",
  details: [
    { label: "Available", value: formatMoney(funds.available) },
    { label: "Required", value: formatMoney(funds.required) },
    { label: "Shortfall", value: formatMoney(funds.shortfall), tone: "error" },
  ],
})
